"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    methods: {
        getCardToken: function (cardObject) {
            return new Promise(function (resolve, reject) {
                Multipayment.getToken(cardObject, function (result) {
                    if (result.resultCode === '000') {
                        resolve(result.tokenObject);
                    }
                    else if (result.resultCode === '901' || result.resultCode === '902') {
                        reject(new Error('現在処理が込み合っております。恐れ入りますがしばらく経ってから再度お試しください。'));
                    }
                    else {
                        reject(new Error('カード番号の確認に失敗しました。入力が正しいかご確認ください。'));
                    }
                });
            });
        }
    }
});
